(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroBannerMsel(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var swatches = root.querySelectorAll('[data-swatch]');
      var mediaItems = root.querySelectorAll('[data-media-item]');

      function pauseVideo(item) {
        var video = item.querySelector('video');
        if (video && !video.paused) {
          video.pause();
        }
      }

      function playVideo(item) {
        var video = item.querySelector('video');
        if (!video) return;
        if (video.getAttribute('preload') !== 'auto') {
          video.setAttribute('preload', 'auto');
        }
        if (video.hasAttribute('autoplay')) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              /* autoplay may be blocked; safe to ignore */
            });
          }
        }
      }

      function activate(color) {
        swatches.forEach(function (btn) {
          var isMatch = btn.getAttribute('data-swatch') === color;
          btn.classList.toggle('is-active', isMatch);
          btn.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
        });

        mediaItems.forEach(function (item) {
          var isMatch = item.getAttribute('data-media-item') === color;
          if (isMatch) {
            item.classList.add('is-active');
            playVideo(item);
          } else {
            item.classList.remove('is-active');
            pauseVideo(item);
          }
        });
      }

      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var color = btn.getAttribute('data-swatch');
          if (btn.classList.contains('is-active')) return;
          activate(color);
        });
      });

      /* Preload the two inactive media assets once the browser is idle,
         so switching colors feels instant without slowing initial paint. */
      var scheduleIdle = window.requestIdleCallback || function (fn) {
        return setTimeout(fn, 1500);
      };

      scheduleIdle(function () {
        mediaItems.forEach(function (item) {
          if (item.classList.contains('is-active')) return;

          var video = item.querySelector('video');
          if (video && video.getAttribute('preload') !== 'auto') {
            video.setAttribute('preload', 'auto');
            video.load();
          }

          var img = item.querySelector('img[loading="lazy"]');
          if (img) {
            img.loading = 'eager';
          }
        });
      });

      var defaultColor = root.getAttribute('data-default-color') || 'yellow';
      activate(defaultColor);
    }

    function initAll(context) {
      var scope = context || document;
      scope.querySelectorAll('.hero-banner-msel').forEach(initHeroBannerMsel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    /* Re-init when the section is re-rendered inside the theme editor */
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
        constructor() {
            super();
        }
        hide() {
            super.hide();
        }
        show(opener) {
            super.show(opener);
            this.showActiveMedia();
        }
        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                element.classList.remove('active');
            })
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                activeMedia.loadContent();
            }
        }
    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-meny"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.lnav').forEach(function (nav) {
      var root = nav.closest('[id^="shopify-section-"]') || document;
      var list = root.querySelector('.lnav__list');
      var innerEl = root.querySelector('.lnav__inner');
      var entries = []; // { item, link, panel, homeParent }

      function isMobile() {
        return window.matchMedia('(max-width: 989px)').matches;
      }

      function closeEntry(entry) {
        entry.item.classList.remove('is-open');
        entry.panel.classList.remove('is-open');
        // return the panel to its original spot inside the item if it was portalled out
        if (entry.panel.parentNode !== entry.homeParent) {
          entry.homeParent.appendChild(entry.panel);
        }
      }

      function closeAll() {
        entries.forEach(closeEntry);
      }

      function openEntry(entry) {
        entries.forEach(function (e) { if (e !== entry) closeEntry(e); });
        entry.item.classList.add('is-open');
        if (isMobile() && innerEl) {
          // escape .lnav__list's edge-fade mask (mask-image clips fixed-position
          // descendants too), while staying inside the scoped section so all
          // styling still matches
          innerEl.appendChild(entry.panel);
          var rect = entry.link.getBoundingClientRect();
          entry.panel.style.top = (rect.bottom + 8) + 'px';
        }
        entry.panel.classList.add('is-open');
      }

      root.querySelectorAll('.lnav__item').forEach(function (item) {
        var link = item.querySelector('.lnav__link');
        var panel = item.querySelector('.lnav__dropdown, .lnav__mega');
        if (!panel || !link) return;

        var entry = { item: item, link: link, panel: panel, homeParent: item };
        entries.push(entry);

        item.addEventListener('mouseenter', function () {
          if (!isMobile()) openEntry(entry);
        });
        item.addEventListener('mouseleave', function () {
          if (!isMobile()) closeEntry(entry);
        });

        link.addEventListener('click', function (e) {
          if (isMobile() || window.matchMedia('(hover: none)').matches) {
            e.preventDefault();
            var wasOpen = entry.item.classList.contains('is-open');
            if (wasOpen) {
              closeEntry(entry);
            } else {
              openEntry(entry);
            }
          }
        });
      });

      // tapping outside an open item's panel closes it
      document.addEventListener('click', function (e) {
        if (e.target.closest('.lnav__dropdown, .lnav__mega, .lnav__item')) return;
        closeAll();
      });

      // scrolling the carousel row invalidates any open panel's position
      if (list) {
        list.addEventListener('scroll', function () { closeAll(); }, { passive: true });
      }
      window.addEventListener('resize', closeAll);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatINR(amount) {
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: 0
        }).format(amount);
      } catch (e) {
        return '₹' + Math.round(amount).toString();
      }
    }

    function initConfigurator(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var makingChargeType = root.dataset.makingChargeType;
      var makingChargeValue = parseFloat(root.dataset.makingChargeValue) || 0;
      var gstPercent = parseFloat(root.dataset.gstPercent) || 0;
      var demoNetWeight = parseFloat(root.dataset.demoNetWeight) || 0;
      var demoStoneWeight = parseFloat(root.dataset.demoStoneWeight) || 0;
      var demoGrossWeightOverride = parseFloat(root.dataset.demoGrossWeight) || 0;

      var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-option-btn]'));
      var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-media-item]'));

      var state = {
        metal: null,
        stone: null,
        purity: null,
        stoneRate: 0,
        goldRate: 0,
        size: null,
        engraving: ''
      };

      function buttonsByRole(role) {
        return optionButtons.filter(function (btn) {
          return btn.getAttribute('data-role') === role;
        });
      }

      function setActiveButton(role, value) {
        buttonsByRole(role).forEach(function (btn) {
          var match = btn.getAttribute('data-value') === value;
          btn.classList.toggle('is-active', match);
          btn.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
      }

      function updateMedia() {
        if (!state.metal || !state.stone) return;
        var metalBtn = buttonsByRole('metal').filter(function (b) { return b.getAttribute('data-value') === state.metal; })[0];
        var stoneBtn = buttonsByRole('stone').filter(function (b) { return b.getAttribute('data-value') === state.stone; })[0];
        if (!metalBtn || !stoneBtn) return;

        var key = metalBtn.getAttribute('data-media-key') + '-' + stoneBtn.getAttribute('data-media-key');

        mediaItems.forEach(function (item) {
          var isMatch = item.getAttribute('data-media-key') === key;
          var video = item.querySelector('video');
          if (isMatch) {
            item.classList.add('is-active');
            if (video) {
              if (video.getAttribute('preload') !== 'auto') video.setAttribute('preload', 'auto');
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            item.classList.remove('is-active');
            if (video && !video.paused) video.pause();
          }
        });
      }

      function preloadRemainingMedia() {
        var scheduleIdle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
        scheduleIdle(function () {
          mediaItems.forEach(function (item) {
            if (item.classList.contains('is-active')) return;
            var video = item.querySelector('video');
            if (video && video.getAttribute('preload') !== 'auto') {
              video.setAttribute('preload', 'auto');
              video.load();
            }
            var img = item.querySelector('img[loading="lazy"]');
            if (img) img.loading = 'eager';
          });
        });
      }

      function setText(key, value) {
        var el = root.querySelector('[data-summary="' + key + '"]');
        if (el) el.textContent = value;
      }

      function updateSummary() {
        setText('metal', state.metal || '—');
        setText('stone', state.stone || '—');
        setText('purity', state.purity || '—');
        setText('size', state.size || '—');
        setText('engraving', state.engraving ? state.engraving : 'Not selected');

        var metaLine = root.querySelector('[data-summary-line]');

        if (!state.metal || !state.stone || !state.purity) {
          setText('netweight', '—');
          setText('stoneweight', '—');
          setText('grossweight', '—');
          setText('price', '—');
          if (metaLine) metaLine.textContent = 'Select your options to begin';
          return;
        }

        var netWeight = demoNetWeight;
        var stoneWeight = demoStoneWeight;
        var grossWeight = demoGrossWeightOverride > 0 ? demoGrossWeightOverride : (netWeight + stoneWeight * 0.2);

        setText('netweight', netWeight.toFixed(3) + ' g');
        setText('stoneweight', stoneWeight.toFixed(3) + ' ct');
        setText('grossweight', grossWeight.toFixed(3) + ' g');

        var goldPrice = netWeight * state.goldRate;
        var stonePrice = stoneWeight * state.stoneRate;
        var making = makingChargeType === 'percentage'
          ? goldPrice * (makingChargeValue / 100)
          : makingChargeValue;
        var subtotal = goldPrice + stonePrice + making;
        var gst = subtotal * (gstPercent / 100);
        var total = subtotal + gst;

        setText('price', formatINR(total));

        if (metaLine) {
          metaLine.textContent = (state.purity || '') + ' · ' + (state.metal || '') + ' · Size ' + (state.size || '—');
        }
      }

      function selectOption(role, btn) {
        var value = btn.getAttribute('data-value');
        state[role] = value;

        if (role === 'metal') updateMedia();
        if (role === 'stone') state.stoneRate = parseFloat(btn.getAttribute('data-rate')) || 0;
        if (role === 'purity') state.goldRate = parseFloat(btn.getAttribute('data-rate')) || 0;

        setActiveButton(role, value);
        updateSummary();
      }

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectOption(btn.getAttribute('data-role'), btn);
        });
      });

      var ringSizeSelect = root.querySelector('[data-ring-size]');
      if (ringSizeSelect) {
        state.size = ringSizeSelect.value;
        ringSizeSelect.addEventListener('change', function () {
          state.size = ringSizeSelect.value;
          updateSummary();
        });
      }

      var engravingInput = root.querySelector('[data-engraving-input]');
      var engravingAddBtn = root.querySelector('[data-engraving-add]');
      if (engravingInput && engravingAddBtn) {
        engravingAddBtn.addEventListener('click', function () {
          state.engraving = engravingInput.value.trim();
          engravingAddBtn.textContent = state.engraving ? 'Added' : 'Add';
          engravingAddBtn.classList.toggle('is-added', !!state.engraving);
          updateSummary();
        });
        engravingInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            engravingAddBtn.click();
          }
        });
      }

      /* Demo defaults: first value in each group */
      var defaultMetalBtn = buttonsByRole('metal')[0];
      var defaultStoneBtn = buttonsByRole('stone')[0];
      var defaultPurityBtn = buttonsByRole('purity')[0];

      if (defaultMetalBtn) selectOption('metal', defaultMetalBtn);
      if (defaultStoneBtn) selectOption('stone', defaultStoneBtn);
      if (defaultPurityBtn) selectOption('purity', defaultPurityBtn);

      preloadRemainingMedia();
    }

    function initAll(context) {
      var scope = context || document;
      scope.querySelectorAll('[data-product-configurator]').forEach(initConfigurator);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
